{
  "name": "@rockcarver/frodo-lib",
  "version": "3.1.0",
  "type": "commonjs",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "require": "./dist/index.js",
      "import": "./dist/index.mjs"
    }
  },
  "scripts": {
    "test": "npm run test:only",
    "test:only": "NODE_OPTIONS=--experimental-vm-modules npx jest --silent",
    "test:debug": "NODE_OPTIONS=--experimental-vm-modules npx jest --silent=false",
    "test:record": "NODE_OPTIONS=--experimental-vm-modules FRODO_POLLY_MODE=record npx jest --silent=false --runInBand --updateSnapshot --testPathPattern",
    "test:record_noauth": "NODE_OPTIONS=--experimental-vm-modules FRODO_POLLY_MODE=record_noauth npx jest --silent=false --updateSnapshot --testPathIgnorePatterns cjs --testPathPattern",
    "test:update": "NODE_OPTIONS=--experimental-vm-modules npx jest --silent=false --updateSnapshot --testPathPattern",
    "lint": "eslint --ext .ts --ignore-path .gitignore .",
    "lint:fix": "eslint --fix --ext .ts --ignore-path .gitignore .",
    "clean-types": "rimraf types",
    "generate-types": "tsc",
    "build": "npx tsup && npm run clean-types && npm run generate-types",
    "doc": "npx typedoc",
    "prettier:fix": "npm run prettier write",
    "dev": "npx tsup --watch src --onSuccess 'npx tsup --dts-only'"
  },
  "description": "A library to manage ForgeRock Identity Cloud tenants, ForgeOps deployments, and classic deployments.",
  "keywords": [
    "ping",
    "pingone",
    "forgerock",
    "library",
    "am",
    "openam",
    "idm",
    "openidm",
    "forgeops",
    "identity cloud",
    "advanced identity cloud",
    "export",
    "import",
    "ci/cd",
    "devops"
  ],
  "engines": {
    "node": ">=18.17.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/rockcarver/frodo-lib.git"
  },
  "bugs": {
    "url": "https://github.com/rockcarver/frodo-lib/issues"
  },
  "contributors": [
    {
      "name": "Sandeep Chaturvedi",
      "email": "sandeep.chaturvedi@forgerock.com"
    },
    {
      "name": "Adam Crockett",
      "email": "adam.crockett@forgerock.com"
    },
    {
      "name": "Mees van Dongen",
      "email": "meesvandongen@gmail.com"
    },
    {
      "name": "Ali Falahi",
      "email": "ali@falahi.com"
    },
    {
      "name": "Huston Franklin",
      "email": "hfranklin@trivir.com"
    },
    {
      "name": "Preston Hales",
      "email": "phales@trivir.com"
    },
    {
      "name": "Nick Hangartner",
      "email": "nhangartner@gmail.com"
    },
    {
      "name": "Marcel Maas",
      "email": "maas.marcel@gmail.com"
    },
    {
      "name": "Conor Barford",
      "email": "conor.barford@pingidentity.com"
    },
    {
      "name": "Joshua Sayers",
      "email": "joshua.sayers@forgerock.com"
    },
    {
      "name": "Volker Scheuber",
      "email": "volker.scheuber@forgerock.com"
    }
  ],
  "license": "MIT",
  "devDependencies": {
    "@jest/globals": "^29.0.1",
    "@pollyjs/adapter-node-http": "^6.0.5",
    "@pollyjs/core": "^6.0.5",
    "@pollyjs/persister-fs": "^6.0.5",
    "@types/esprima": "^4.0.3",
    "@types/fs-extra": "^11.0.1",
    "@types/jest": "^29.5.12",
    "@types/lodash": "^4.14.189",
    "@types/mock-fs": "^4.13.1",
    "@types/node": "^22.13.10",
    "@types/node-forge": "^1.3.11",
    "@types/properties-reader": "^2.1.1",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^7.12.0",
    "@typescript-eslint/parser": "^7.12.0",
    "agentkeepalive": "^4.2.1",
    "axios": "^1.7.4",
    "axios-mock-adapter": "^2.1.0",
    "axios-retry": "^4.4.0",
    "colors": "^1.4.0",
    "copyfiles": "^2.4.1",
    "del": "^8.0.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^10.1.1",
    "eslint-plugin-deprecation": "^3.0.0",
    "eslint-plugin-import": "^2.28.0",
    "eslint-plugin-jest": "^28.5.0",
    "eslint-plugin-prettier": "^5.0.0",
    "eslint-plugin-simple-import-sort": "^12.1.0",
    "esprima": "^4.0.1",
    "fs-extra": "^11.1.1",
    "jest": "^29.3.1",
    "jest-jasmine2": "^29.7.0",
    "loglevel": "^1.9.1",
    "map-stream": "^0.0.7",
    "mock-fs": "^5.2.0",
    "node-forge": "^1.3.1",
    "node-jose": "^2.2.0",
    "prettier": "^3.2.5",
    "properties-reader": "^2.2.0",
    "proxy-agent": "^6.5.0",
    "qs": "^6.10.3",
    "replaceall": "^0.1.6",
    "rimraf": "^6.0.1",
    "setup-polly-jest": "^0.11.0",
    "slugify": "^1.6.5",
    "ts-jest": "^29.1.2",
    "tsup": "^8.0.2",
    "typedoc": "^0.27.9",
    "typedoc-plugin-missing-exports": "^3.1.0",
    "typescript": "^5.8.2",
    "uuid": "^11.1.0"
  }
}
